import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId, MAPPA_URL } from "../../config";
import { FlagIT } from "./primitives";
import { trackMappaClick } from "../../analytics";

const LINKS = [
  { label: "La Mappa", href: "#la-mappa" },
  { label: "Come Funziona", href: "#come-funziona" },
  { label: "La Storia", href: "#storia" },
  { label: "Domande", href: "#faq" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header data-testid="navbar" className="border-b border-white/10 bg-ink/70 backdrop-blur-xl">
      <div className="mx-auto flex h-[68px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <a
          href="#top"
          onClick={(e) => go(e, "#top")}
          data-testid="navbar-logo"
          className="font-serif text-sm sm:text-base font-semibold tracking-[0.25em] text-white"
        >
          FEDE <span className="text-gold">&</span> FITNESS{" "}
          <span className="hidden sm:inline">ITALIA</span>{" "}
          <FlagIT className="h-3 w-[18px] align-baseline" />
        </a>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Navigazione principale">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-xs font-medium uppercase tracking-[0.2em] text-white/60 transition-colors duration-300 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <motion.a
            href={MAPPA_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackMappaClick("navbar-cta")}
            data-testid="navbar-cta"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.96 }}
            className="hidden cursor-pointer rounded-full bg-gold px-6 py-2.5 text-[11px] font-semibold uppercase tracking-[0.15em] text-black transition-colors duration-300 hover:bg-gold-bright sm:inline-flex"
          >
            Richiedi la Mappa
          </motion.a>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-button"
            aria-label={open ? "Chiudi menu" : "Apri menu"}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-white/10 bg-ink/95 backdrop-blur-xl lg:hidden"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col gap-1 px-6 py-6">
              {LINKS.map((l, i) => (
                <motion.a
                  key={l.href}
                  href={l.href}
                  onClick={(e) => go(e, l.href)}
                  initial={{ opacity: 0, x: -16 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.05 * i }}
                  data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="py-3 font-serif text-2xl font-light text-white/85 transition-colors duration-300 hover:text-gold"
                >
                  {l.label}
                </motion.a>
              ))}
              <a
                href={MAPPA_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackMappaClick("mobile-menu-cta")}
                data-testid="mobile-menu-cta"
                className="mt-4 cursor-pointer rounded-full bg-gold px-6 py-4 text-center text-xs font-semibold uppercase tracking-[0.2em] text-black"
              >
                Richiedi la Mappa del Tempio
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
